import { colors } from '@styles/global/colors'
import { ITheme } from '@styles/themes/darkTheme'

const darkSlate = `#545659`
const highlight1 = `#D78612`
const mainColor = `#212837`
const ProcreatePatternsTheme: ITheme = {
  type: 'default',
  textColor: mainColor,
  bodyText: mainColor,
  subheaderColor: highlight1,
  headlineColor: mainColor,
  headlineColorAlt: highlight1,
  backgroundPrimary: `#F6F2EC`,
  backgroundSecondary: `#fff`,
  lineColor: `#e1e4e9`,
  linkColor: '#ea653d',
  linkHoverColor: colors.blue.i600,
  logoColor: `#333F4F`,
  highlight: {
    i300: `#F6F2EC`,
    i500: highlight1,
  },
  outline: `${colors.grey.i600}`,
  buttonPrimary: {
    backgroundColor: `#fff`,
    backgroundHoverColor: mainColor,
    textColor: highlight1,
    textHoverColor: `#fff`,
  },
  shadows: {
    i800: {
      hover: `0px 40px 50px rgb(245, 196, 182)`,
      init: `0px 40px 50px rgba(0, 0, 0, 0)`,
    },
  },
  nav: {
    openColor: '#fff',
    color: colors.purple.i500,
    textColor: colors.primary.text,
    background: '#fff'
  },

}

export default ProcreatePatternsTheme
